import React, { useEffect, createElement } from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { TomiSection } from './components/TomiSection';
import { InsideCarousel } from './components/InsideCarousel';
import { BonusSection } from './components/BonusSection';
import { PricingCard } from './components/PricingCard';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      // Meta Pixel initialization
      ;
      (function (f: any, b: any, e: any, v: any) {
        if (f.fbq) return;
        const n: any = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement(e);
        t.async = !0;
        t.src = v;
        const s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          ;
          (b.head || b.documentElement).appendChild(t);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq('init', '1747467019720990');
      (window as any).fbq('track', 'PageView');
    } catch (err) {
      console.warn('Meta Pixel init skipped:', err);
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="nvj4pj9gikrb">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1747467019720990&ev=PageView&noscript=1" alt="" data-id="element-1" data-mp="nw2ay2pqvkpi" />
      </noscript>
      <div className="min-h-screen bg-brand-ivory text-brand-text overflow-x-hidden flex flex-col items-center" data-id="element-2" data-mp="34x2njg6zd4f">
        <div className="w-full max-w-3xl bg-white shadow-2xl" data-id="element-3" data-mp="3uevrrz7vo833">
          <UrgencyBanner data-id="element-4" data-mp="d3mmhhrnf7nb" />
          <Hero data-id="element-5" data-mp="d3wbp34vdary" />
          <PainSection data-id="element-6" data-mp="d2bjhk6123x9" />
          <TomiSection data-id="element-7" data-mp="85ul7x54696g" />
          <InsideCarousel data-id="element-8" data-mp="86mh792mi8x9" />
          <BonusSection data-id="element-9" data-mp="86cm572q1bkp" />
          <PricingCard data-id="element-10" data-mp="3gle7gc7darc0" />
          <Guarantee data-id="element-11" data-mp="3gkv1ltuzrtec" />
          <Testimonials data-id="element-12" data-mp="3gm64zskiyz4x" />
          <FAQ data-id="element-13" data-mp="3glo2ie79rook" />
          <FinalCTA data-id="element-14" data-mp="3gj1qa19fol00" />
          <Footer data-id="element-15" data-mp="3bmjnv81ksyqu" />
        </div>
      </div>
    </>;
}